/**
 * WAT-11617: the app's route root for fetches to Express/API routes
 * (e.g. /uf/sierra-chat/, /uf/api/*). Exactly two values by design
 * (see WAT-11617 review decision):
 *   - "/uf" in production builds — the standard UF build serves under /uf
 *     (package.json "homepage")
 *   - ""    otherwise (local dev / test)
 *
 * Deliberately NOT derived from server/utils/server-constant `root`
 * (fs at import time — unsafe in client chunks) and deliberately simpler
 * than the runtime asset-URL sniffing in rum/inpCapture: this app has no
 * per-env base-path variance, so a build-time constant is sufficient.
 *
 * Replaces reads of window.__NEXT_DATA__.assetPrefix, which is
 * Pages-Router-only — on the App Router it resolved to "" and the
 * unprefixed fetch 404'd. NODE_ENV is inlined at build time, so this is
 * a compile-time constant on the client.
 */
export const APP_BASE_PATH = process.env.NODE_ENV === "production" ? "/uf" : "";
